import { OverlayTrigger, Tooltip } from "react-bootstrap"
import "./CustomIconButton.scss"

type Props = {
  children: JSX.Element
  onClick: (e: any) => void
  variant: "delete" | "edit"
  title?: string
}

const renderTooltip = (title: string) => (
  title ? (<Tooltip className="button-tooltip">
    {title}
  </Tooltip >) : <></>
);

const CustomIconButton = ({children, onClick, variant, title}: Props) => {
  return children ? (
		<OverlayTrigger
			placement="bottom"
			overlay={renderTooltip(title || '')}
			trigger={['hover', 'focus']}
			rootClose
			delay={{ show: 0, hide: 0 }}
		>
			<div className={`custom-icon-button spaces mx-2 ${variant}`} onClick={onClick}>
				{children}
			</div>
		</OverlayTrigger>
  ) : (
		<div className={`custom-icon-button spaces mx-2 ${variant}`} onClick={onClick}>
			{children}
		</div>
  );
}

export default CustomIconButton
